import { environments } from 'environments/environments'
import { ViaCepResponseDTO } from 'models'
import api from './api'

const { ENDPOINT_VIACEP } = environments

export const getCEP = async (cep: string): Promise<ViaCepResponseDTO> => {
    return await api
        .get(`${ENDPOINT_VIACEP}/cep/${cep}`)
        .then(response => response.data)
        .catch(error => error)
}
